import trans from '../../trans';

/**
 * Карточка товара
 */
 export class AppDetail {
    /**
     * Инициализация объекта
     * @param {string} containerId 
     * @param {json} params 
     */
    constructor(containerId, params) {
        this.container = $('#' + containerId);
        this.data = params;
        this.selected = new Map();
        this.offer = {};
        this.lang = window._locale;
        
        this.init();
        this.setupEvents();
    };

    /**
     * инифиализация
     */
    init() {
        let context = this;

        let important = {};
        $.each(this.data, function(key, item){
            if(parseInt(item.master) == 1){
                important = item;
            }
        })

        if(Object.keys(important).length == 0){
            $.each(this.data, function(key, item){
                if(key == 0){
                    important = item;
                }
            })
        }

        let arrVariants = this.data;
        arrVariants.splice(0, 1);

        $.each(arrVariants, function(key, arrVariant){
            let quantity = arrVariant.quantity;
            $.each(arrVariant.options, function(keyY, item){
                let value = item[context.lang];
                let dataQuantity = parseInt($('.characteristic-item[data-id="'+ keyY +':'+ value +'"]').attr('data-quantity')) + parseInt(quantity);
                $('.characteristic-item[data-id="'+ keyY +':'+ value +'"]').attr('data-quantity',dataQuantity);
                if(dataQuantity == 0){
                    $('.characteristic-item[data-id="'+ keyY +':'+ value +'"]').addClass('disable');
                } else {
                    $('.characteristic-item[data-id="'+ keyY +':'+ value +'"]').removeClass('disable');
                }
            });
        });
        
        // установка вариации по умолчанию
        $.each(important.options, function(key, item){
            let value = item[context.lang];
            context.selected.set(key, value);
        });

		this.findOffer();

		//this.setImages();
    };

    /**
     * События
     */
    setupEvents() {
        let context = this;

        /**
         * Выбор опции
         */
        this.container.find('.characteristics-block__row .characteristic-item').on('click', function () {
            $(this).parent().find('.characteristic-item').removeClass('active');
            $(this).addClass('active');
            $('.characteristic-item').removeClass('notSelected'); //Убрать предупреждение о невыбранном размере
            $('.color_error_text').removeClass('show');

            let params = $(this).data('id').split(':');
            // удаление текущего значение
            context.selected.delete(params[0]);

            // установка нового значение опции
            context.selected.set(params[0], parseInt(params[1]));
            
            // поиск вариации по параметрам опций
            context.findOffer();

            // установка параметров для кнопок (положить в корзину и т.д.)
            context.setParamsButton();

            // вывод цены вариации, артикула и т.д.
            context.setOfferData();

            // установка картинок
            //context.setImages();

			return false;
        });
    };

	findOffer(){
        let context = this;

        context.offer = {};

		// поиск вариации
        $.each(this.data, function(key, variant){
            let option = new Map();
            $.each(variant.options, function(key, item){
                let value = item[context.lang];
                option.set(key, parseInt(value));
            });
            
            if(context._mapEquals(context.selected, option)){
                context.offer = variant;
            }
        });
		
	};

	setOfferData(){
		// вывести цены и т.д.
        let price = 0;
        let offerId = 0;
        
        if(Object.keys(this.offer).length > 0){
            console.log(this.offer);
            let koefCurrency = window.currencies[this.offer.code];
            price = parseFloat(this.offer.price) * parseFloat(koefCurrency);
            offerId = this.offer.id;
        }
        $('.information-block .variant').html(this.offer.name);
        this.container.find('[data-container="price"] .cost-block__num').html('<strong>' + price.toFixed(2)+'</strong> грн.');
        this.container.find('[data-action="add_basket"]').attr('data-variant-id', offerId);
	};

    setImages(){
        let context = this;
        if(Object.keys(context.offer).length > 0){
            let containerSlider = context.container.find('.product-slider');
            context.container.find('.product-slider').slick('unslick');
            context.container.find('.nav-slider').slick('unslick');

            containerSlider.find('.product-slider__item').remove();
            context.container.find('.nav-slider .nav-slider__item').remove();

            $.each(context.offer.images, function(key, image){
                switch(key){
                    case 1:
                        if(context.offer.video){
                            let content = `<a href="`+ context.offer.video.link +`"  class="product-slider__item video_play" data-fancybox="product-images" data-width="2048" data-height="1365" >
                                <div class="img-wrapper">
                                    <picture>
                                        <source srcset="`+ context.offer.video.image +`">
                                        <img src="`+ context.offer.video.image +`">
                                    </picture>
                                </div></a>`;
                            containerSlider.append(content);
            
                            let contentNav = `<a href="#" class="nav-slider__item video_play">
                                <div class="img-wrapper">
                                    <picture>
                                        <source srcset="`+ context.offer.video.image +`">
                                        <img src="`+ context.offer.video.image +`">
                                    </picture>
                                </div></a>`;
                            context.container.find('.nav-slider').append(contentNav);
                        }
                        break;
                }
                let content = `<a href="`+ image.attachment.relativeUrl +`" class="product-slider__item" data-fancybox="product-images">
                <div class="img-wrapper">
                    <picture>
                        <source srcset="`+ image.attachment.relativeUrl +`">
                        <img src="`+ image.attachment.relativeUrl +`" alt="`+ image.attachment.original_name +`">
                    </picture>
                </div></a>`;

                containerSlider.append(content);

                let contentNav = `<a href="#" class="nav-slider__item">
                <div class="img-wrapper">
                    <picture>
                        <source srcset="`+ image.attachment.relativeUrl +`">
                        <img src="`+ image.attachment.relativeUrl +`" alt="`+ image.attachment.original_name +`">
                    </picture>
                </div></a>`;

                context.container.find('.nav-slider').append(contentNav);
            });
            context.productSliderInit('.product-slider', '.nav-slider');
        }
    };

    productSliderInit(slider, navSlider){
        $(slider).slick({
            lazyLoad: 'ondemand',
            arrows: false,
            slidesToShow: 1,
            asNavFor: navSlider,
            infinite: false,
            dots: false,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        asNavFor: false,
                        dots: true
                    }
                }, 
            ]
        })
    
        $_navSlider = $(navSlider).slick({
            lazyLoad: 'ondemand',
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: false,
            draggable: false,
            asNavFor: slider,
            infinite: false
        })
    
        $_navSlider.find('.slick-slide').on('click', function(e){
            // let images = document.querySelectorAll(".lazyload");
            // lazyload(images);
            $_navSlider.slick('slickGoTo', $(e.currentTarget).data('slick-index'));
        })
    };

    setParamsButton(){
        
    };

    _mapEquals(leftMap, rightMap) {
        if (leftMap == rightMap) return true;
        if (leftMap == null || rightMap == null || leftMap.size != rightMap.size) return false;
        for (let key of leftMap.keys()) {
            let value1 = leftMap.get(key);
            let value2 = rightMap.get(key);
            if (value1 == null && value2 == null)
                continue;
            else if (value1 == null || value2 == null)
                return false;
            if (value1 != value2)
                return false;
        }
        return true;
    };
}
document.addEventListener("DOMContentLoaded", function() {
    const lazyPictures = document.querySelectorAll("picture.lazyload");

    if ("IntersectionObserver" in window) {
        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const picture = entry.target;
                    const sources = picture.querySelectorAll("source");
                    const img = picture.querySelector("img");

                    sources.forEach(source => {
                        source.srcset = source.dataset.srcset;
                    });

                    if (img) {
                        img.src = img.dataset.src;
                    }

                    picture.classList.remove("lazyload");
                    observer.unobserve(picture);
                }
            });
        });

        lazyPictures.forEach(picture => observer.observe(picture));
    } else {
        // Фолбэк для браузеров, которые не поддерживают IntersectionObserver
        lazyPictures.forEach(picture => {
            const sources = picture.querySelectorAll("source");
            const img = picture.querySelector("img");

            sources.forEach(source => {
                source.srcset = source.dataset.srcset;
            });

            if (img) {
                img.src = img.dataset.src;
            }

            picture.classList.remove("lazyload");
        });
    }
});